import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Button, Typography } from '@mui/material';
import dayjs from 'dayjs';
import PropType from 'prop-types';

import { COMMON_DATE_FORMAT } from 'constants/date';

import { closeDialogAction } from 'store/global/actions';

import { UnderwritingTestIds } from '../../../../Underwriting.testIds';

const CancelSendingBundlePopup = ({ date, onConfirm }) => {
  const dispatch = useDispatch();

  const handleSubmit = useCallback(async () => {
    await onConfirm();

    dispatch(closeDialogAction());
  }, [dispatch, onConfirm]);

  return (
    <div className="flex flex-col items-stretch">
      <Typography className="max-w-320" variant="regular14">
        Are you sure you want to cancel CD bundle scheduled for{' '}
        {date ? `${dayjs(date).format(COMMON_DATE_FORMAT)}` : 'N/A'}?
      </Typography>
      <div className="self-end">
        <Button
          className="mt-16"
          data-testid={UnderwritingTestIds.BROKER_CONDITION_FORM_CANCEL_CD_BUNDLE_BUTTON}
          variant="contained"
          onClick={handleSubmit}
        >
          Yes
        </Button>
      </div>
    </div>
  );
};

CancelSendingBundlePopup.propTypes = {
  date: PropType.string.isRequired,
  onConfirm: PropType.func.isRequired,
};

export default CancelSendingBundlePopup;
